import React from 'react';
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from "@stripe/stripe-js/pure";
import CheckoutForm from "./CheckoutForm";
import {STRIPE_KEY} from "../../config.json";

const stripePromise = loadStripe(STRIPE_KEY);

const PayCard = (props) => (
    <Elements stripe={stripePromise}>
        <CheckoutForm {...props} />
    </Elements>
);
export default PayCard;
